import { ReactNode } from 'react';
import createSafeContext from '@paradigm/utils/src/createSafeContext';
import { usePositionsWebsocket } from '#/positions/contexts/websocket';
import {
  PositionsNotification,
  PositionsWebSocket,
} from '#/positions/entities/types';
import {
  SubscriptionState,
  useSubscriber,
} from '#/positions/contexts/abstractions/useSubscriber';

const CHANNELS = ['position_updates'];
const TOPIC = 'positions-subscription';

export const [usePositionsSubscriberStatus, PositionsSubscriberContext] =
  createSafeContext<SubscriptionState>('PositionsSubscriberStatus');

interface Props {
  children: ReactNode;
}

export function PositionsSubscriptionProvider(props: Props) {
  const { children } = props;
  const ws = usePositionsWebsocket();
  const state = useSubscriber<PositionsWebSocket, PositionsNotification>(
    ws,
    CHANNELS,
    TOPIC,
  );

  return (
    <PositionsSubscriberContext value={state}>
      {children}
    </PositionsSubscriberContext>
  );
}
